import style from './index.module.scss';
import { EditableImg } from '@smartfire/components';
import { useEditor } from '@smartfire/js-block-engine';

function Logo() {
    const { isEditing } = useEditor();
    const Wrapper = isEditing ? 'div' : 'a';

    return (
        <Wrapper className={style.link} href="/">
            <EditableImg smartProp={'big_logo'} className={style.bigLogo} />
        </Wrapper>
    );
}

export default Logo;
